import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarTipoSorteio, setModalDeletarTipoSorteio } from "../redux/slices/tipoSorteio/tipoSorteioSlice";

export const cadastrarTipoSorteio = createAsyncThunk("/TipoSorteio/CadastrarTipoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/TipoSorteio/CadastrarTipoSorteio/", payload.value);
    toastSucess("Tipo do sorteio cadastrado com sucesso");
    dispatch(setModalCadastrarTipoSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarTipoSorteio = createAsyncThunk("/TipoSorteio/BuscarTipoSorteio", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/TipoSorteio/BuscarTipoSorteio", { params: { pesquisar: pesquisar } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarTipoSorteio = createAsyncThunk("/TipoSorteio/AtualizarTipoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TipoSorteio/AtualizarTipoSorteio/", payload.value);
    toastSucess("Tipo do sorteio atualizado com sucesso");
    dispatch(setModalCadastrarTipoSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarTipoSorteioAtivo = createAsyncThunk("/TipoSorteio/AtualizarTipoSorteioAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TipoSorteio/AtualizarTipoSorteioAtivo?id=" + payload.value.id + "&ativo=" + payload.value.ativo);
    toastSucess("Status de ativo do tipo do sorteio atualizada com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarTipoSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarTipoSorteio = createAsyncThunk("/TipoSorteio/DeletarTipoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/TipoSorteio/DeletarTipoSorteio/?id=" + payload.value);
    toastSucess("Tipo do sorteio removido com sucesso");
    dispatch(setModalDeletarTipoSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
